module.exports = __webpack_public_path__ + "img/support-calculator.eacecb3a.svg";